import { apiSalesWeb } from '@shared/config';

export interface IGetSessionAuth {
  id: string;
  externalToken: string;
  alreadyUsed: boolean;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export async function getSessionAuth(id: string) {
  return apiSalesWeb.get<IGetSessionAuth>(`/session-auth/${id}`);
}
